import { ConfigProvider as BrandConfigProvider } from "antd";
import { ABSTRACT_BACKGROUND, BRAND_THEME } from "../../../../libs/constants";
import React from "react";
import * as Yup from "yup";
import { Box, Grid, Paper, Typography } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import {
  workflowContainerCheckPointById,
  workflowContainerCheckPointPost,
  workflowContainerCheckPointPut,
  workflowContainerFullForCPByContainer,
} from "../../../../libs/apis";
import { Button as ButtonAntd, ConfigProvider, message, Popconfirm, Space } from "antd";
import { CheckCircleFilled, ClearOutlined } from "@ant-design/icons";
import { ThirdComponent } from "./thrid-component/page";
import { useWidth, useLocalStorage } from "../../../../libs/hooks";
import { COLOR_PRIMARY, COLOR_SECONDARY } from "../../../../libs/constants";
import { NAVBAR_HEIGHT_SUM } from "../../../../libs/constants";
import { useWorkflowCheckpointStore } from "../../store";
import { css } from "@emotion/css";
import { useRouterStore } from "../../../../libs/stores";
import Swal from "sweetalert2";
import { obtenerFotoConWatermarkBase64 } from "../../../../libs/hooks";

const WorkflowAddComponent = () => {
  const width = useWidth();

  return (
    <BrandConfigProvider theme={BRAND_THEME}>
    <Grid
      container
      spacing={0.5}
      justifyContent="center"
      sx={{
        mt: 0,
        maxHeight: `calc(100vh - ${NAVBAR_HEIGHT_SUM})`,
        minHeight: `calc(100vh - ${NAVBAR_HEIGHT_SUM})`,
        height: `calc(100vh - ${NAVBAR_HEIGHT_SUM})`,
        overflowY: "hidden",
        overflowX: "hidden",
        ...ABSTRACT_BACKGROUND,
      }}
    >
      <Grid item xs={12} md={6}>
        <Paper elevation={2} sx={{ m: width === "xs" ? 0 : 1 }}>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Component width={width} />
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    </Grid>
    </BrandConfigProvider>
  );
};

interface ComponentPropsI {
  width: string;
}

const Component = ({ width }: ComponentPropsI) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const setSection = useRouterStore((state) => state.setSection);

  const [isProcessing, setProcessing] = React.useState(false);
  const { getPrefixCls } = React.useContext(ConfigProvider.ConfigContext);
  const rootPrefixCls = getPrefixCls();

  const getDataContainerCheckPoint = useWorkflowCheckpointStore(
    (state) => state.getDataContainerCheckPoint
  );
  const getOnlyPhotos = useWorkflowCheckpointStore((state) => state.getOnlyPhotos);
  const setDataContainerCheckPoint = useWorkflowCheckpointStore(
    (state) => state.setDataContainerCheckPoint
  );
  const onClear = useWorkflowCheckpointStore((state) => state.onClear);
  const setDataCF = useWorkflowCheckpointStore((state) => state.setDataCF);
  const [activeKey, setActiveKey] = useLocalStorage<string[]>(
    "active-key-checkpoint",
    ["1"]
  );

  const validationSchema = Yup.object({
    siglasPhoto: Yup.string(),
    adhesivoPhoto: Yup.string(),
    cableVerificadoraPhoto: Yup.string(),
    
    botellaVerificadoraRastreoPhoto: Yup.string(),
    numRastreoSatelitalPhoto: Yup.string(),
    adhesivoPuertaPhoto: Yup.string(),
    adhesivoBisagraPhoto1: Yup.string(),
    adhesivoBisagraPhoto2: Yup.string(),
    adhesivoBisagraPhoto3: Yup.string(),
    cableExporPhoto: Yup.string(),
    botellaExporPhoto: Yup.string(),
    botellaNavieraPhoto: Yup.string(),
    ventoleraIzquierdaPhoto: Yup.string(),
    ventoleraDerechaPhoto: Yup.string(),
    panelIzquierdoPhoto: Yup.string(),
    panelDerechoPhoto: Yup.string(),
    // inspectionContainerPhoto: Yup.string().required(
    //   "Foto Inspección Contenedor Requerida"
    // ),
    container: Yup.string().required("Número de Contenedor Requerido"),
  });

  React.useEffect(() => {
    handleGetData();
    setSection("CheckPoint ✅");

    return () => {
      setSection("");
      if (id) {
        onClear();
        setActiveKey(["1"]);
      }
    };
  }, []);

  const handleGetData = async () => {
    try {
      if (id) {
        const { data: dataWf } = await workflowContainerCheckPointById(
          Number(id)
        );
        if (!dataWf) return;
        setDataContainerCheckPoint(dataWf);
        const { data: dataCF } = await workflowContainerFullForCPByContainer(
          dataWf.container
        );
        if (!dataCF) return;
        setDataCF(dataCF);
      }
    } catch (err:any) {
      console.log(err);
      message.error(err.toString());
    }
  };

  async function buildFinalData() {
    const dateHelper = new Date();
    const data = { ...getOnlyPhotos() };
    const dataTotal = { ...getDataContainerCheckPoint() };
    dataTotal.timeStampSave = dateHelper.toISOString();
    dataTotal.hourSaveUser = dateHelper.toLocaleTimeString();

    for (const [clave, valor] of Object.entries(data)) {

      if (!valor || valor.startsWith("http://") || valor.startsWith("https://") || valor.startsWith("data:")) continue;
      data[clave] = await obtenerFotoConWatermarkBase64(
        valor as string,
      );
    }



    return { ...dataTotal, ...data };
  }

  const handleSave = async () => {
    try {
      setProcessing(true);
      message.loading("Procesando las fotos", 0);
      const objPost = await buildFinalData();
      await validationSchema.validate(objPost);
      const missingPhotos = Object.keys(objPost as any).filter(
        (key) => /Photo\d*$/.test(key) && !(objPost as any)[key]
      );
      if (missingPhotos.length > 0) {
        message.warning(
          `Registro guardado. Faltan ${missingPhotos.length} foto(s) por subir.`,
          5
        );
      }
      message.destroy();
      message.loading("Guardando Información", 0);

      if (id) {
        const { data: dataPut } = await workflowContainerCheckPointPut(
          Number(id),
          objPost
        );
        if (!dataPut) return;
        message.destroy();
        message.success(dataPut);
      } else {
        const { data: dataPost } = await workflowContainerCheckPointPost(
          objPost
        );
        if (!dataPost) return;
        message.destroy();
        message.success(dataPost.alert);
      }

      onClear();
      navigate("/container/checkpoint/list");

      setProcessing(false);
    } catch (err: any) {
      message.destroy();
      setProcessing(false);
      message.error(err.toString());
    }
  };

  const linearGradientButton = css`
    &.${rootPrefixCls}-btn-primary:not([disabled]):not(
        .${rootPrefixCls}-btn-dangerous
      ) {
      border-width: 0;

      > span {
        position: relative;
      }

      &::before {
        content: "";
        background: linear-gradient(135deg, ${COLOR_PRIMARY}, ${COLOR_SECONDARY});
        position: absolute;
        inset: 0;
        opacity: 1;
        transition: all 0.3s;
        border-radius: inherit;
      }

      &:hover::before {
        opacity: 0;
      }
    }
  `;

  const handleResetWithFear = () => {
    Swal.fire({
      title: "¡Atención!",
      html: `<p style="font-weight:bolder; color:red">Estás a punto de BORRAR todo. <br/> ¿Estás seguro?</p>`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      confirmButtonText: "Sí, eliminar todo",
      cancelButtonText: "No, cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        // Aquí sí ejecutas el borrado real
        onClear();
        Swal.fire({
          title: "¡Listo!",
          text: "Toda la información fue borrada",
          icon: "success",
          confirmButtonColor: "#1E3A5F",

        });
      }
    });
  };

  return (
    <Box sx={{ position: "relative" }}>
      <Box
        sx={{
          position: "absolute",
          top: -10,
          width: "100%",
          height: 50,
          bgcolor: "white",
          zIndex: 701,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          p: 0.5,
          borderBottom: "1px dashed gainsboro",
          borderRadius: 1,
        }}
      >
        <Typography
          variant="overline"
          display="block"
          gutterBottom
          sx={{
            fontSize: 16,
            fontWeight: "bolder",
            color: "grey",
            height: 30,
          }}
        >
          CheckPoint
        </Typography>
        <div>
          <ConfigProvider
            button={{
              className: linearGradientButton,
            }}
          >
            <Space size="small">
              <Popconfirm
                title="Se borrará toda la Información"
                description="Desea Continuar?"
                onConfirm={handleResetWithFear}
                zIndex={1101}
                okText="Si"
                cancelText="No"
              >
                <ButtonAntd
                  size="middle"
                  type="primary"
                  danger
                  icon={<ClearOutlined />}
                />
              </Popconfirm>
              <Popconfirm
                title="Finalizar Proceso"
                description="Si Finaliza no podrá editar la Información"
                onConfirm={handleSave}
                okText="Si"
                cancelText="No"
                icon={<CheckCircleFilled />}
                zIndex={1601}
              >
                <ButtonAntd
                  size="middle"
                  loading={isProcessing}
                  disabled={isProcessing}
                  type="primary"
                  icon={<CheckCircleFilled />}
                >
                  Finalizar
                </ButtonAntd>
              </Popconfirm>

            </Space>
          </ConfigProvider>
        </div>
      </Box>
      <ThirdComponent
        width={width}
        activeKey={activeKey}
        setActiveKey={setActiveKey}
      />
    </Box>
  );
};

export default WorkflowAddComponent;
